import * as React from "react";
import { UitkPrimaryButton } from "uitk-react-button";
import { decorateEditorialHtml } from "../../../../ContentUtilities";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

export const CitiLearnMoreButton = (props: { items: EditorialModel[]; cardComparisonClassName: string }) => {
  const { items, cardComparisonClassName } = props;
  if (items.length !== 1) {
    return null;
  }

  const onClickLearnMore = (): void => {
    const [cardComparisonElement] = document.getElementsByClassName(
      cardComparisonClassName
    ) as HTMLCollectionOf<HTMLElement>;
    window.scrollTo({
      behavior: "smooth",
      top: cardComparisonElement?.offsetTop,
    });
  };

  return (
    <>
      <UitkPrimaryButton type="button" onClick={onClickLearnMore}>
        <div dangerouslySetInnerHTML={decorateEditorialHtml(items[0].text)} />
      </UitkPrimaryButton>
    </>
  );
};

export default CitiLearnMoreButton;
